import BaseReportStore from '../BaseReportStore'

class OvertimeReportStore extends BaseReportStore {
    constructor() {
        super()
        this.convertedData = null
    }

    setConvertedData(data) {
        this.convertedData = data
    }

    getConvertedData() {
        return this.convertedData
    }

    getTimeFormat() {
        return this.timeFormat
    }
}

const store = new OvertimeReportStore()
export default store


// WEBPACK FOOTER //
// ./web/js/reports/overtimeReport/OvertimeReportStore.js